import BudgetReconciliationBillAlert from 'tio-employee/components/budget-reconciliation-bill-alert';
import { t } from 'ember-intl';
import { Header, VStack } from 'tio-reimagined/components/layout';

<template>
  <VStack>
    <BudgetReconciliationBillAlert />
    <Header>{{t "idr.default"}}</Header>
    {{outlet}}
  </VStack>
</template>
